import ProductList from '@/data/product/view/list.vue'
import ProductEditor from '@/data/product/view/editor.vue'
import sortableListView from '@/data/product/view/list-sortable.vue'
import monthlyStatisticsView from '@/data/product/view/monthly-statistics.vue'

const list = {
  path: '/product',
  name: 'product-list',
  component: ProductList
}
const creator = {
  path: '/product/creator',
  name: 'createProduct',
  component: ProductEditor
}
const editor = {
  path: '/product/editor/:id(\\d+)',
  name: 'updateProduct',
  component: ProductEditor
}

const sortableList = {
  path: '/product/sorting',
  name: 'product-list-sortable',
  component: sortableListView
}

const monthlyStatistics = {
  path: '/product-statistics',
  name: 'product-statistics',
  component: monthlyStatisticsView
}

export default [list, creator, editor, sortableList, monthlyStatistics]
